export type ThemeVariablesType = {
  colors: {
    primary: string;
    primaryDarker: string;
    primaryLighter: string;
    backgroundGray: string;
    backgroundGrayDarker: string;
    backgroundPrimary: string;
    backgroundPrimaryRGB: string;
    primaryLight: string;
    lightGray: string;
    primaryGradient: string;
    secondary: string;
    dark: string;
  };
  textColors: {
    primary: string;
    gray: string;
  };
  fontSizes: {
    normal: string;
    medium: string;
    large: string;
    xLarge: string;
    xxLarge: string;
    xxxLarge: string;
    smaller: string;
    subtitle: string;
    xSmall: string;
  };
  fontWeights: {
    thin: number;
    extraLight: number;
    light: number;
    regular: number;
    medium: number;
    bold: number;
    semibold: number;
    extraBold: number;
    black: number;
  };
  semanticColors: {
    success: string;
    successBackground: string;
    error: string;
    errorBackground: string;
    warning: string;
    informative: string;
  };
};

export const themeVariables: ThemeVariablesType = {
  colors: {
    primary: '#1f446e',
    primaryDarker: '#1f446e',
    secondary: '#FF9241',
    backgroundGray: '#e0e0e0',
    backgroundGrayDarker: 'gray',
    primaryLighter: '#FA6328',
    backgroundPrimary: '#ffffff',
    backgroundPrimaryRGB: '255, 255, 255',
    primaryLight: '#ef7e51',
    lightGray: '#F6F9FC',
    primaryGradient: 'linear-gradient(to right top, #f44f30 0%, #f57430 60%, #f6923c 100%)',
    dark: '#221E1F'
  },
  textColors: {
    gray: 'gray',
    primary: '#232b31'
  },
  fontSizes: {
    normal: '1rem',
    medium: '1.25rem',
    large: '1.5rem',
    xLarge: '1.75rem',
    xxLarge: '2.5rem',
    xxxLarge: '4rem',
    smaller: '0.8rem',
    subtitle: '0.9rem',
    xSmall: '0.75rem'
  },
  fontWeights: {
    thin: 200,
    extraLight: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extraBold: 800,
    black: 900
  },
  semanticColors: {
    success: '#34C687',
    error: '#E23636',
    warning: '#ffc608',
    informative: '#1f446e',
    successBackground: '#c8facd',
    errorBackground: '#f6c9cb'
  }
};
